//Equal height JS
function equalHeight() {
  $.fn.extend({
    equalHeight: function () {
      var top = 0;
      var row = [];
      var classname = ("equalHeight" + Math.random()).replace(".", "");
      $(this)
        .each(function () {
          var thistop = $(this).offset().top;
          if (thistop > top) {
            $("." + classname).removeClass(classname);
            top = thistop;
          }
          $(this).addClass(classname);
          $(this).height("auto");
          var h = Math.max.apply(
            null,
            $("." + classname)
              .map(function () {
                return $(this).outerHeight();
              })
              .get()
          );
          $("." + classname).height(h);
        })
        .removeClass(classname);
    },
  });
  setTimeout(function () {
    //$(".product-item:not(.nosto-item) .prod-title a").equalHeight();
    $(".product-item:not(.nosto-item) .prod-img a").equalHeight();
    $(".product-grid .grid__item .card__heading a").equalHeight();
    $ (".search-tabbing .product-grid .product-item").equalHeight();

    $(".top-products-block .slider-wrapper .product-item .prod-title").equalHeight();
    $(".menu-product .product-item .prod-title").equalHeight();
    $(".frequently-item-slider .product-item .prod-title").equalHeight();
    $(".megamenu-wrapper  .product-item .item-inner").equalHeight();
    $(".facets-vertical .product-grid-container .product-grid .item-inner").equalHeight();
  },500);

  
  var set_interval = 
   setInterval(function () {
     if ($('.nosto_element .product-item').hasClass('active-equal-height')){
         clearInterval(set_interval);
     }
     else{
    $(".nosto_element .product-item .prod-title a").equalHeight();
    // $(".nosto_element .product-item .prod-img a").equalHeight();
     $(".nosto_element .product-item").addClass('active-equal-height'); 
     }
  }, 9000);


}


/* mega menu */
function mega_menu() {
  $(".header .header__inline-menu .nav-bar .megamenu-li").mouseenter(function(){
    $('body').addClass('menu-open');
});
  $(".header .header__inline-menu .nav-bar .megamenu-li").mouseleave(function(){
    $('body').removeClass('menu-open');
});
}
function fix_header(){
    var header_height = $('.header').outerHeight();
    var ann_height = $('.sticky-announcement-bar').outerHeight();
    $('.sticky-announcement-bar').css("top", header_height);
    $('.main').css("margin-top", header_height + ann_height);
  
}
function footer_accordion(){
  $('.footer-block--menu .footer-block__heading').click(function (e){
    if($(window).width() < 767){
      e.stopPropagation();
      e.preventDefault();
      $('.footer-block--menu').not($(this).parent('.footer-block--menu')).removeClass('open');
      $('.footer-block--menu').not($(this).parent('.footer-block--menu')).find('.footer-block__details-content').slideUp();
      $(this).parent('.footer-block--menu').find('.footer-block__details-content').slideToggle();  
      $(this).parent('.footer-block--menu').toggleClass('open');
    }        
  });
}

function tabbing() {
  $(".pdp-tab-block .tab-content .tab-item").hide();
  $($(".pdp-tab-block .tab-link.active a").attr("href")).show();
  $(".pdp-tab-block .tab-link a")
    .off()
    .click(function (e) {
      e.preventDefault();
      var tab_link_id = $(this).attr("href");
      $(".tab-links-wrap .tab-link.active").removeClass("active");
      $(".tab-links-wrap .tab-link a[href=" + tab_link_id + "]").parent().addClass("active");
      $(".tab-content .tab-link a[href=" + tab_link_id + "]").parent().siblings().removeClass("active");
      if($(".tab-content .tab-link a[href=" + tab_link_id + "]").parent().hasClass("active")){
        $(".tab-content .tab-link a[href=" + tab_link_id + "]").parent().removeClass("active");
      }
      else{
        $(".tab-content .tab-link a[href=" + tab_link_id + "]").parent().addClass("active");
      }
      if ($(window).width() > 767) {
        $(".tab-content .tab-item").hide();
        $($(this).attr("href")).fadeIn(500);
      } 
      else {
        var link_id = $(this).attr("href");
        link_id = link_id.substring(1, link_id.length);
        var active_Tab;
        $(".tab-item").each(function () {
          if ($(this).attr("id") == link_id) {
            active_Tab = $(this);
          }
        });
        $(".tab-content .tab-item").not(active_Tab).slideUp();
        $($(this).attr("href")).slideToggle();        
      }
          equalHeight();  
      });
}

function filter_mobile() {
    $('.filter-toggle-btn .filter-btn:not(.open-default-filter)').click(function (e) {
      $("body").addClass("filter-open");
    });
    $(document).on('click', `.main-collection-wrapper .open-default-filter`, function(event){
      event.preventDefault();
      $('.main-collection-wrapper .mobile-facets__wrapper summary.mobile-facets__open-wrapper').trigger('click')
    });
    $('.product-main-container .sidebar .mobile-close').click(function(e){
      $("body").removeClass("filter-open");
    });
    $('body').click(function (e) {
      $("body").removeClass("filter-open");
    });
    $('.sidebar, .filter-btn:not(.open-default-filter)').click(function(e){
      e.stopPropagation();
    });
}
function filter_sticky_btn() {
  var topHeight = $("header").innerHeight() + $(".toolbar").innerHeight();
  if($(window).scrollTop() > topHeight){
    $(".filter-toggle-btn.sticky-filter").addClass("active");
  }
  else{
    $(".filter-toggle-btn.sticky-filter").removeClass("active");
  }
}
function frequentlyBoughtSlider() {
  if($(window).width() <= 767){
    $('.frequently-item-slider').slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      infinite:false,
      centerMode:false,
      prevArrow: $('.freq-prev'),
      nextArrow: $('.freq-next'),
      responsive: [
        {
          breakpoint: 350,
          settings: {
            slidesToShow: 1.2
          }
        },
      ]
    });
  }
  else{
    $('.frequently-item-slider').slick('unslick');
  }
}

/* mobile menu product slider */

function mobile_menu_slider(){
  if($(".mobile-menu-product-slider").length > 0){
    $('.mobile-menu-product-slider').not('.slick-initialized').slick({
      slidesToShow: 1.2,
      slidesToScroll: 1,
      infinite:false,
      centerMode:false,
      prevArrow: $('.menu-prev'),
      nextArrow: $('.menu-next'),
    });   
  }
}

function scroll_to() {
  if($(".cms-page .scroll-to").length > 0){
     $(".cms-page li .scroll-to").click(function (e) {
      e.preventDefault();
       var header_height = $(".header").outerHeight() + 15;
       var target = $(this).attr('href');
       $('html, body').animate({
         scrollTop: ($(target).offset().top - header_height)
       }, 500);
    });
  }
}

function faq_accordion(){  
  if($(".faq-accordion").length > 0){
    $(".faq-accordion").find(".accordion-item:first-child").find(".accordion-content").slideDown();
    $(".faq-accordion .accordion-title").click(function(){
     
      $(this).parent(".accordion-item").find(".accordion-content").slideToggle();
      $(this).parent(".accordion-item").toggleClass("active");
      $(this).parent(".accordion-item").siblings(".accordion-item").find(".accordion-content").slideUp(); 
      $(this).parent(".accordion-item").siblings(".accordion-item").removeClass("active");       
    });
  }
}

function common_sidebar_accordion(){  
  if($(".common-accordion-wrapper").length > 0){
    if($(window).width() <= 991){
      $(".accordion-item.mobile-close").addClass("closed");  
      $(".accordion-item.mobile-close .accordion-content").hide();
    } else{
      $(".accordion-item.mobile-close").removeClass("closed");
      $(".accordion-item.mobile-close .accordion-content").show();
    }
    $(".accordion-item.closed .accordion-content").hide();
    $(".common-accordion-wrapper .accordion-item .accordion-title").off().click(function(){
      $(this).parent(".accordion-item").find(".accordion-content").slideToggle();
      $(this).parent(".accordion-item").toggleClass("closed");
    });    
  }
}

function aboutus_img_position() {
  if($(".about-us-section").length > 0){
	var image_left = $(".about-us-section .img-content-row:not(.row-reverse) .image-block").offset().left;
    	$(".about-us-section .img-content-row:not(.row-reverse) .image-block .inner-wrap").css({
    		left: image_left + "px"
	});
    var image_right = $(".about-us-section .img-content-row.row-reverse .content-block").offset().left;
    	$(".about-us-section .img-content-row.row-reverse .image-block .inner-wrap").css({
    		right: image_right + "px"
	});
  }
}

function reply_comment() {
  if($(".comment-wrap .reply").length > 0){
     $(".comment-wrap .reply").click(function (e) {
      e.preventDefault();
       var header_height = $(".header").outerHeight() + 15;
       var target = $(".comment-reply");
       $('html, body').animate({
         scrollTop: ($(target).offset().top - header_height)
       }, 500);
        $(".accordion-item.comment-reply").find(".accordion-content").slideDown();
        $(".accordion-item.comment-reply").removeClass("closed");
    });
  }
}

function search_tabbing (){

$(".search-tabs .search-link")
    .off()
    .click(function (e) {
      e.preventDefault();
      equalHeight();
     
	$(this.hash).fadeIn(200).siblings().fadeOut(200);
   	e.preventDefault();
	}).first().click();

    $(".search-tabs .search-link").on("click",function(){
   $(".search-tabs .search-link.active").removeClass("active");
   $(this).addClass("active");
       
}); 
}



/*end*/


/*end*/
$(document).ready(function () {
  equalHeight();
  mega_menu();
  fix_header();
  footer_accordion();
  filter_mobile();
  filter_sticky_btn();
  search_tabbing();
  tabbing();  
   setTimeout(function () {
    equalHeight();  
  }, 400);
  // frequentlyBoughtSlider();
  if($(window).width() <= 767){
    frequentlyBoughtSlider();
  }
  mobile_menu_slider();
  scroll_to();
  faq_accordion();
  common_sidebar_accordion();
  aboutus_img_position();
  reply_comment();

  /*1-5-25_start  */
  $('.product-media-modal .product-media-modal__content').slick({
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
  });
		
  /*1-5-25_end  */

  $(".search-tabs .search-link")
    .off()
    .click(function (e) {
         equalHeight();  
    });
  $(".menu-drawer__navigation>.menu-drawer__menu>li>details>summary").click(function () {
    $('.mobile-menu-product-slider').slick('refresh');
    setTimeout(function () {
      equalHeight();  
    }, 200);
  });

  /*modal-js*/

  $('.quick-buy-modal').on('click', function() {
        //$('body').addClass("modal-open");
  });
  $('.close-modal').on('click', function() {
        $('body').removeClass("modal-open");
  });

   // Landing page Modal
  $(".modal").on('click', function() {
    $("body").addClass('open-model');
  }); 
  $(".close-btn, .bg-overlay").click(function(){
    $("body").removeClass('open-model');
  });
  
/*end*/

 $(document).on('click', `facet-remove>a, .facets-wrap .facets__item`, function(event){
     setTimeout(function(){
        equalHeight();  
      },500)
  });
  
  var myInterval = setInterval(function(){
    if($(".top-product-slider").length > 0){
      if($('.top-product-slider .product-item').hasClass('slick-slide')){
        clearInterval(myInterval);
      }else{
        if($('.top-product-slider .product-item').length > 0){
          $('.top-product-slider').not('.slick-initialized').slick({
            slidesToShow: 6.5,
            slidesToScroll: 1,
            infinite:false,
            centerMode:false,
            prevArrow: $('.prev'),
            nextArrow: $('.next'),
            responsive: [
              {
                breakpoint: 1680,
                settings: {
                  slidesToShow: 5.5
                }
              },
              {
                breakpoint: 1440,
                settings: {
                  slidesToShow: 4.5
                }
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3.5
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2.5
                }
              },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1.8
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1.4
                }
              }
            ]
          }); 
        }
      }
    }
  }, 100)  
 
  /* manage mcustom scroll bar */
  var li_length = $(".sidebar .filter-accordian .accordian-content ul li").length;
  if( li_length > 13){
    $(".sidebar  .filter-accordian .accordian-content .category-list").mCustomScrollbar({
    axis:"y",
  });
  }
  else(
     $(".sidebar .filter-accordian .accordian-content .category-list").css("height","auto")
  )
  
  /* end */
  $(".sidebar .filter-accordian .accordian-title").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).closest(".filter-accordian").find(".accordian-content").slideToggle();
    $(this).closest(".filter-accordian").toggleClass("closed");
  })


});
$(window).resize(function () {

   setTimeout(function () { 
    aboutus_img_position();
    common_sidebar_accordion();
  }, 200);
});
jQuery(window).on("resize", function () {
  mega_menu();
  fix_header();
  filter_sticky_btn();
  tabbing();
  // frequentlyBoughtSlider();
  if($(window).width() <= 767){
    frequentlyBoughtSlider();
  }
  mobile_menu_slider();
  
  setTimeout(function () {
    equalHeight();  
  }, 100);
});

jQuery(window).on("load", function () {
  mega_menu();
  fix_header();
  tabbing();
  filter_sticky_btn();
  search_tabbing ();
    setTimeout(function () {
    equalHeight();  
  }, 500);
  // frequentlyBoughtSlider();
  if($(window).width() <= 767){
    frequentlyBoughtSlider();
  }
   mobile_menu_slider();
  common_sidebar_accordion();
 
});


jQuery(window).on("scroll", function () {
  filter_sticky_btn();
});

$('body').on('click', '.slick-arrow', function () {
      equalHeight(); 
})